/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useUnboundInteractionGetAll = makeQueryHook(
  operations.unboundInteractionGetAll,
)

export const useUnboundInteractionGetById = makeQueryHook(
  operations.unboundInteractionGetById,
)

export const useUnboundInteractionDelete = makeMutationHook(
  operations.unboundInteractionDelete,
)

export const useUnboundGetManyPreviousInteractions = makeQueryHook(
  operations.unboundGetManyPreviousInteractions,
)

export const useInteractionConvoGet = makeQueryHook(
  operations.interactionConvoGet,
)

export const useInteractionConvoJoin = makeMutationHook(
  operations.interactionConvoJoin,
)

export const useInteractionConvoLeave = makeMutationHook(
  operations.interactionConvoLeave,
)

export const useInteractionConvoClose = makeMutationHook(
  operations.interactionConvoClose,
)

export const useUnboundInteractionDownloadRecording = makeQueryHook(
  operations.unboundInteractionDownloadRecording,
)

export const useUnboundInteractionDownloadVoicemail = makeQueryHook(
  operations.unboundInteractionDownloadVoicemail,
)

export const useUnboundInteractionCallTranscriptionResultsGetByInteraction =
  makeQueryHook(
    operations.unboundInteractionCallTranscriptionResultsGetByInteraction,
  )

export const useUnboundInteractionSubmitCallTranscriptionRequest =
  makeMutationHook(operations.unboundInteractionSubmitCallTranscriptionRequest)

export const useUnboundInteractionCallTranscriptionResultsGet = makeQueryHook(
  operations.unboundInteractionCallTranscriptionResultsGet,
)

export const useUnboundInteractionCallTranscriptionResultsUpdate =
  makeMutationHook(operations.unboundInteractionCallTranscriptionResultsUpdate)

export const useUnboundInteractionSubmitCallSummaryRequest = makeMutationHook(
  operations.unboundInteractionSubmitCallSummaryRequest,
)

export const useUnboundInteractionCallSummaryResultsGet = makeQueryHook(
  operations.unboundInteractionCallSummaryResultsGet,
)

export const useUnboundInteractionCallSummaryResultsUpdate = makeMutationHook(
  operations.unboundInteractionCallSummaryResultsUpdate,
)

export const useUnboundInteractionCallSummaryResultsGetByInteraction =
  makeQueryHook(operations.unboundInteractionCallSummaryResultsGetByInteraction)

export const useInteractionGetAll = makeQueryHook(operations.interactionGetAll)

export const useInteractionAdd = makeMutationHook(operations.interactionAdd)

export const useInteractionGetById = makeQueryHook(
  operations.interactionGetById,
)

export const useInteractionUpdate = makeMutationHook(
  operations.interactionUpdate,
)

export const useInteractionDelete = makeMutationHook(
  operations.interactionDelete,
)

export const useGetManyPreviousInteractions = makeQueryHook(
  operations.getManyPreviousInteractions,
)

export const useInteractionDownloadRecording = makeQueryHook(
  operations.interactionDownloadRecording,
)

export const useInteractionDownloadVoicemail = makeQueryHook(
  operations.interactionDownloadVoicemail,
)

export const useCallTranscriptionResultsGetByInteraction = makeQueryHook(
  operations.callTranscriptionResultsGetByInteraction,
)

export const useSubmitCallTranscriptionRequest = makeMutationHook(
  operations.submitCallTranscriptionRequest,
)

export const useCallTranscriptionResultsGet = makeQueryHook(
  operations.callTranscriptionResultsGet,
)

export const useCallTranscriptionResultsUpdate = makeMutationHook(
  operations.callTranscriptionResultsUpdate,
)

export const useSubmitCallSummaryRequest = makeMutationHook(
  operations.submitCallSummaryRequest,
)

export const useCallSummaryResultsGet = makeQueryHook(
  operations.callSummaryResultsGet,
)

export const useCallSummaryResultsUpdate = makeMutationHook(
  operations.callSummaryResultsUpdate,
)

export const useCallSummaryResultsGetByInteraction = makeQueryHook(
  operations.callSummaryResultsGetByInteraction,
)

export const useGetInteractionCases = makeQueryHook(
  operations.getInteractionCases,
)

export const useInteractionSearch = makeQueryHook(operations.interactionSearch)

export const useInternalUnboundInteractionGetAll = makeQueryHook(
  operations.internalUnboundInteractionGetAll,
)

export const useUnboundInteractionAdd = makeMutationHook(
  operations.unboundInteractionAdd,
)

export const useInternalUnboundInteractionGetById = makeQueryHook(
  operations.internalUnboundInteractionGetById,
)

export const useUnboundInteractionUpdate = makeMutationHook(
  operations.unboundInteractionUpdate,
)

export const useInternalUnboundInteractionDelete = makeMutationHook(
  operations.internalUnboundInteractionDelete,
)

export const useInternalUnboundGetManyPreviousInteractions = makeQueryHook(
  operations.internalUnboundGetManyPreviousInteractions,
)

export const useInternalInteractionConvoGet = makeQueryHook(
  operations.internalInteractionConvoGet,
)

export const useInternalInteractionConvoJoin = makeMutationHook(
  operations.internalInteractionConvoJoin,
)

export const useInternalInteractionConvoLeave = makeMutationHook(
  operations.internalInteractionConvoLeave,
)

export const useInternalInteractionConvoClose = makeMutationHook(
  operations.internalInteractionConvoClose,
)

export const useInternalUnboundInteractionDownloadRecording = makeQueryHook(
  operations.internalUnboundInteractionDownloadRecording,
)

export const useInternalUnboundInteractionDownloadVoicemail = makeQueryHook(
  operations.internalUnboundInteractionDownloadVoicemail,
)

export const useInternalUnboundInteractionCallTranscriptionResultsGetByInteraction =
  makeQueryHook(
    operations.internalUnboundInteractionCallTranscriptionResultsGetByInteraction,
  )

export const useInternalUnboundInteractionSubmitCallTranscriptionRequest =
  makeMutationHook(
    operations.internalUnboundInteractionSubmitCallTranscriptionRequest,
  )

export const useInternalUnboundInteractionCallTranscriptionResultsGet =
  makeQueryHook(
    operations.internalUnboundInteractionCallTranscriptionResultsGet,
  )

export const useInternalUnboundInteractionCallTranscriptionResultsUpdate =
  makeMutationHook(
    operations.internalUnboundInteractionCallTranscriptionResultsUpdate,
  )

export const useInternalUnboundInteractionSubmitCallSummaryRequest =
  makeMutationHook(
    operations.internalUnboundInteractionSubmitCallSummaryRequest,
  )

export const useInternalUnboundInteractionCallSummaryResultsGet = makeQueryHook(
  operations.internalUnboundInteractionCallSummaryResultsGet,
)

export const useInternalUnboundInteractionCallSummaryResultsUpdate =
  makeMutationHook(
    operations.internalUnboundInteractionCallSummaryResultsUpdate,
  )

export const useInternalUnboundInteractionCallSummaryResultsGetByInteraction =
  makeQueryHook(
    operations.internalUnboundInteractionCallSummaryResultsGetByInteraction,
  )
